import React from 'react'
import BlueScreenOfDeath from './BlueScreenOfDeath'

export default function NotFoundPage(): JSX.Element {
    return <BlueScreenOfDeath />
}
